export const QUICK_ACTIONS_VIEW = 'quick-actions';

export const HELP_CENTER_ROUTE_PATHS = {
  quickActions: '/help-center/quick-actions',
};

export const HELP_CENTER_API_PATHS = {
  list: '/v1/api/platform/help-center/quick-actions',
  createAction: '/v1/api/platform/help-center/quick-action',
  updateAction: '/v1/api/platform/help-center/quick-action/:quickActionId',
  createConfig: '/v1/api/platform/help-center/quick-action-config',
  updateConfig: '/v1/api/platform/help-center/quick-action-config/:quickActionConfigId',
};

/** Client-side page size (table pagination is done in the browser — see FETCH_SIZE below). */
export const PAGE_SIZE = 50;

/**
 * Upstream's list endpoint (SupportController#getAllQuickActions) accepts only page/size — no
 * filter query params — so the panel fetches one large page and filters/paginates client-side
 * (same pattern as content's CATEGORIES_FETCH_SIZE) rather than showing a paginator whose totals
 * only reflect the unfiltered page.
 */
export const FETCH_SIZE = 500;

/**
 * Query keys for React Query.
 * Hierarchical structure for cache management.
 */
export const QuickActionsKeys = {
  all: () => ['help-center', 'quick-actions'] as const,
  list: () => [...QuickActionsKeys.all(), 'list'] as const,
};
